<mat-card appearance="outlined">
  <mat-card-title>404 - Page not found</mat-card-title>
  <mat-card-subtitle>
    The page you seek is not available. Go to dashboard.
  </mat-card-subtitle>
</mat-card>
